import { render, staticRenderFns } from "./CBProposalBusinessNature.vue?vue&type=template&id=d0cebcec"
import script from "./CBProposalBusinessNature.vue?vue&type=script&lang=js"
export * from "./CBProposalBusinessNature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports